/**
 * LoginModal.js
 * 
 * 檔案標頭註解：
 * 改版日期時間：2025-07-16 14:35:00
 * 版本：V1.01
 * 檔案主要功能與職責：夥伴登入模態框，提供攤位編號和密碼驗證功能
 * 這個檔案是做什麼的？它解決了什麼問題？
 * - 提供夥伴登入介面
 * - 支援攤位編號和密碼驗證
 * - 支援初始密碼設定
 * - 處理帳號停用狀態
 * - 提供錯誤訊息顯示
 * 
 * 版本更新說明：
 * V1.01 (2025-01-16) - 初始版本，從 App.js 模組化搬移
 * 
 * 注意事項：
 * - 需要傳入 vendors 陣列進行驗證
 * - 需要傳入 onLoginSuccess 回調函數
 * - 支援 Firebase 資料庫操作
 * - 支援帳號狀態檢查
 * 
 * 關連檔案：
 * - App.js (主要使用此模組)
 * - Firebase 認證系統
 */

import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';

const LoginModal = ({ onClose, vendors, onLoginSuccess, db, appId }) => {
    const [id, setId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async () => {
        setError('');
        const vendor = vendors.find(v => v.id.toLowerCase() === id.toLowerCase());
        
        if (vendor) {
            if (vendor.isActive === false) {
                setError('此帳號已被停用，請聯繫管理員。');
                return;
            }
            
            if (vendor.password) {
                if (vendor.password === password) {
                    onLoginSuccess(vendor);
                } else {
                    setError('密碼錯誤！');
                }
            } else if (password) {
                try {
                    const vendorRef = doc(db, `artifacts/${appId}/public/data/vendors`, vendor.id);
                    await updateDoc(vendorRef, { password: password });
                    onLoginSuccess({ ...vendor, password: password });
                } catch (err) {
                    setError('設定初始密碼失敗，請稍後再試。');
                }
            } else {
                setError('請輸入您的初始密碼。');
            }
        } else {
            setError('找不到此攤位編號！');
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm p-6" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold mb-6 text-center">夥伴登入</h2>
                <div className="space-y-4">
                    <input 
                        type="text" 
                        value={id} 
                        onChange={e => setId(e.target.value)} 
                        placeholder="請輸入攤位編號" 
                        className="w-full p-3 border rounded-lg" 
                    />
                    <input 
                        type="password" 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        placeholder="請輸入密碼" 
                        className="w-full p-3 border rounded-lg" 
                    />
                    {error && <p className="text-red-500 text-center">{error}</p>}
                    <button 
                        onClick={handleLogin} 
                        className="w-full bg-blue-500 text-white font-bold py-3 rounded-lg"
                    >
                        登入
                    </button>
                    <button 
                        onClick={onClose} 
                        className="w-full bg-gray-200 text-gray-800 font-bold py-2 rounded-lg mt-2"
                    >
                        取消
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginModal; 